<template>
  <div id="lo-efficiency-status-popup">
    <v-overlay :value="DeleteLoadingFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-overlay :value="LoadingFlag === true" absolute color="transparent" opacity="1" class="custom-loader">
      <div class="loader-container">
        <!-- From Uiverse.io by Ratinax -->
        <div class="loader1">
          <div class="intern"></div>
          <div class="external-shadow">
            <div class="central"></div>
          </div>
        </div>
        <br>

        <br>
        <p class="loader-text">
          Hold on! Your points are being generated automatically<span class="loader-dots"></span>
        </p>
      </div>
    </v-overlay>
    <v-container class="py-0">
      <v-speed-dial v-model="fab" :top="top" :bottom="bottom" :right="right" :left="left" :direction="direction"
        :open-on-hover="hover" :transition="transition" :fixed="true" v-if="SpeedDialFlag">
        <template v-slot:activator>
          <v-btn v-model="fab" color="blue darken-2" dark fab>
            <v-icon v-if="fab">mdi-close</v-icon>
            <v-icon v-else>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <!-- <v-btn fab dark small color="green">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>-->
        <v-btn fab dark small color="indigo" @click.prevent="addRecord">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <!-- <v-btn fab dark small color="red">
          <v-icon>mdi-delete</v-icon>
        </v-btn>-->
      </v-speed-dial>
    </v-container>
    <v-dialog v-model="previewRecordPrompt" persistent max-width="75%">
      <events-preview pageTitle="Events Preview" pageDescription="Events Preview"
        :previewRecordPrompt="previewRecordPrompt" @hidePreviewRecordPrompt="hidePreviewRecordPrompt"
        :recordData="selectedData" v-if="previewRecordPrompt"></events-preview>
    </v-dialog>
    <v-dialog v-model="scoreRecordPrompt" persistent max-width="75%">
      <events-score-preview pageTitle="Events Score" pageDescription="Validate 100% efficiency events"
        :scoreRecordPrompt="scoreRecordPrompt" @hideScoreRecordPrompt="hideScoreRecordPrompt" :recordData="selectedData"
        v-if="scoreRecordPrompt"></events-score-preview>
    </v-dialog>
    <v-dialog v-model="descriptionPrompt" max-width="550" content-class="elevation-0"
      transition="dialog-bottom-transition">
      <v-card class="description-dialog">
        <div class="description-title d-flex align-center justify-space-between">
          <div class="d-flex align-center gap-3">
            <div class="description-icon-box">
              <v-icon size="24" color="white">mdi-information-outline</v-icon>
            </div>
            <div>
              <h3 class="headline-text">Description</h3>
              <p class="subtitle-text">Event Details Information</p>
            </div>
          </div>
          <v-btn icon small color="white" @click="hideDescriptionPrompt" class="close-top-btn">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider class="my-0"></v-divider>
        <v-card-text class="description-body">
          <div class="text-content" v-if="selectedDescription">
            {{ selectedDescription }}
          </div>
          <div class="empty-state-small" v-else>
            <v-icon size="48" color="primary" opacity="0.3">mdi-text</v-icon>
            <p class="text-grey">No description available</p>
          </div>
        </v-card-text>
        <v-divider class="my-0"></v-divider>
        <v-card-actions class="description-actions">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="hideDescriptionPrompt" class="close-action-btn">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialogPrompt" max-width="600" content-class="elevation-0"
      transition="dialog-bottom-transition">
      <v-card class="error-description-dialog">
        <div class="error-description-header">
          <div class="error-header-icon">
            <v-icon size="24" color="white">mdi-information-variant</v-icon>
          </div>
          <h3 class="error-header-title">{{ errorDialogTitle }}</h3>
          <v-btn icon small class="error-header-close-btn" @click="hideErrorDialogPrompt">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="error-description-content">
          <div class="error-content-header">
            <v-icon small color="info" class="mr-2">mdi-information-outline</v-icon>
            <h4 class="error-section-title">What You Need to Know</h4>
          </div>
          <div class="error-content-body">
            <div class="error-content-inner" v-html="errorDialogContent"></div>
          </div>
        </div>
        <div class="error-description-footer">
          <v-btn class="error-action-btn-secondary" text @click="hideErrorDialogPrompt">
            <v-icon size="18" left>mdi-close</v-icon>
            Close
          </v-btn>
          <v-btn class="error-action-btn-primary" @click="hideErrorDialogPrompt">
            <v-icon size="18" left>mdi-check-circle</v-icon>
            I Understand
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-card elevation="12" class="header-card mb-0 overflow-hidden">
      <div class="header-gradient">
        <v-container fluid class="header-container">
          <v-row align="center" justify="space-between" class="ma-0">
            <!-- Title Section - Left -->
            <v-col cols="12" md="8" class="d-flex align-center gap-3">
              <div class="header-icon-box">
                <v-icon size="28" class="icon-white">mdi-target-variant</v-icon>
              </div>
              <div class="header-title-bar">
                <h2 class="header-title">100% Efficiency Status</h2>
                <p class="header-subtitle">
                  List of 100% efficiency status of LOM
                </p>
              </div>
            </v-col>

            <!-- Action Buttons - Right -->
            <v-col cols="12" md="4" class="d-flex justify-end gap-2">
              <v-btn icon small color="white" class="header-action-btn" @click="refreshPageData">
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
              <v-btn icon small color="white" class="header-action-btn" @click="closePrompt">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card>
    <v-card class="content-card">
      <v-card-text class="page-content">
        <v-row wrap>
          <v-col align="start" cols="12" md="12">
            <div class="notes-content">
              <!-- <p><span class="text-danger">*</span> indicates required field</p> -->
            </div>
          </v-col>
        </v-row>
        <!-- Status Cards -->

        <v-row wrap align="stretch" class="status-cards-row mb-8">
          <v-col cols="12" md="4" class="mb-4 d-flex px-3">
            <voting-count :key="LomCode" :LomCode="LomCode" class="flex-grow-1" style="height: 100%"></voting-count>
          </v-col>
          <v-col cols="12" md="4" class="mb-4 d-flex px-3">
            <v-card class="status-card elevation-8 flex-grow-1" :class="{
              'status-card--success': tableOptions1.EfficiencyFlag,
              'status-card--pending': !tableOptions1.EfficiencyFlag,
            }">
              <v-card-title class="status-card-title">
                <v-icon left size="32">mdi-target</v-icon>
                100% Efficiency Status
              </v-card-title>
              <v-card-text class="status-card-content">
                <div class="status-value">
                  {{ tableOptions1.EfficiencyStatusText }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="4" class="mb-4 d-flex px-3">
            <v-card class="status-card elevation-8 status-card--info flex-grow-1">
              <v-card-title class="status-card-title">
                <v-icon left size="32">mdi-star</v-icon>
                Total Points Earned
              </v-card-title>
              <v-card-text class="status-card-content">
                <div class="status-value points-value">
                  {{ tableOptions1.TotalPoints }}
                </div>
                <div class="points-breakdown">
                  <div class="point-item">
                    <span class="point-label">Compulsory:</span>
                    <span class="point-value">{{
                      tableOptions1.CompulsaryPoints
                    }}</span>
                  </div>
                  <div class="point-item">
                    <span class="point-label">Bonus:</span>
                    <span class="point-value">{{
                      tableOptions1.BonusPoints
                    }}</span>
                  </div>
                  <div class="point-item">
                    <span class="point-label">Optional:</span>
                    <span class="point-value">{{
                      tableOptions1.OptionalPoints
                    }}</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- No Records State -->
        <v-container class="py-0" v-if="tableData1.length == 0 && !LoadingFlag">
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <div class="empty-state">
                <v-icon size="80" color="primary" opacity="0.3">mdi-database</v-icon>
                <h3 class="mt-4">No records found</h3>
                <p class="text-grey">
                  Select a year and LOM to view efficiency status
                </p>
              </div>
            </v-col>
          </v-row>
        </v-container>

        <!-- Data Available State -->
        <v-container class="py-0" v-if="tableData1.length > 0 && !LoadingFlag">
          <!-- Download Button -->
          <v-row wrap class="mb-6">
            <v-col align="center" cols="12" md="12">
              <json-excel v-if="
                tableData1.length > 0 &&
                tableOptions1.JsonDownloadButtonFlag == true
              " :name="tableOptions1.ExcelFileName" :data="tableData1" :fields="tableOptions1.JsonExcelFields">
                <v-btn color="success" dark rounded elevation="8" class="download-btn premium-btn">
                  <v-icon left>mdi-download</v-icon>
                  <span class="btn-text">Download Report</span>
                  <v-icon right>mdi-file-excel</v-icon>
                </v-btn>
              </json-excel>
            </v-col>
          </v-row>

          <!-- Search Section -->
          <v-row wrap class="mb-6">
            <v-col cols="12" md="12">
              <div class="search-section">
                <v-icon left class="search-icon" color="primary">mdi-magnify</v-icon>
                <v-text-field v-model="search" label="Search criteria or keywords..." outlined dense rounded
                  class="search-field" prepend-icon="" clearable @click:clear="search = ''"></v-text-field>
              </div>
            </v-col>
          </v-row>

          <!-- Automatic Points Table -->
          <v-row wrap v-if="tableDataAutomatic.length > 0" class="mb-8">
            <v-col cols="12" md="12">
              <v-card class="table-card elevation-12 data-table-card automatic-card">
                <v-card-title class="table-card-title automatic-title">
                  <div class="title-with-icon">
                    <v-icon left color="success" size="28">mdi-robot</v-icon>
                    <span class="font-weight-bold">Automatic Points</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="records-badge">
                    <v-icon small left>mdi-database</v-icon>
                    <span>{{ tableDataAutomatic.length }} Records</span>
                  </div>
                </v-card-title>
                <v-divider class="my-0"></v-divider>
                <div class="table-wrapper">
                  <v-data-table class="professional-table striped-table" :search="search" :loading="TableLoadingFlag"
                    :item-key="tableOptions1.ItemKey" :headers="tableColumnsAutomatic" :items="tableDataAutomatic"
                    :items-per-page="tableOptions1.ItemsPerPage" :footer-props="tableOptions1.FooterProps">
                    <template v-slot:item.ActiveStatusTxt="{ item }">
                      <div class="d-flex align-center gap-2">
                        <v-btn v-if="item.ComingSoonFlag" x-small rounded color="warning" dark outlined
                          class="coming-soon-btn">
                          <v-icon left x-small>mdi-clock-outline</v-icon>
                          Coming Soon
                        </v-btn>
                        <v-btn v-else-if="item.ScoreBtnFlag" x-small rounded color="primary" dark
                          :loading="UpdateEfficiencyScoreLoadingFlag" :disabled="UpdateEfficiencyScoreLoadingFlag"
                          @click="addScore(item)">
                          <v-icon left x-small>mdi-check-circle-outline</v-icon>
                          Check
                        </v-btn>
                        <v-chip v-else :color="getActiveStatusColor(item.ActiveStatusTxt)" dark small outlined
                          class="status-chip">
                          <v-icon left x-small>mdi-check-circle</v-icon>
                          {{ item.ActiveStatusTxt }}
                        </v-chip>
                        <v-tooltip top v-if="item.Description">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="info" class="info-icon"
                              @click="showDescriptionPrompt(item.Description)" v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>View Description</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div class="table-actions-group">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon x-small color="info" @click="previewData(item)" v-bind="attrs" v-on="on"
                              class="action-icon-btn">
                              <v-icon small>mdi-file-search</v-icon>
                            </v-btn>
                          </template>
                          <span>Preview Details</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon x-small color="warning" @click="scoreData(item)" v-bind="attrs" v-on="on"
                              class="action-icon-btn">
                              <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit & Score</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <!-- Manual Points Table -->
          <v-row wrap v-if="tableDataManual.length > 0" class="mb-8">
            <v-col cols="12" md="12">
              <v-card class="table-card elevation-12 data-table-card">
                <v-card-title class="table-card-title">
                  <div class="title-with-icon">
                    <v-icon left color="warning" size="28">mdi-pencil</v-icon>
                    <span class="font-weight-bold">Manual Points</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="records-badge">
                    <v-icon small left>mdi-database</v-icon>
                    <span>{{ tableDataManual.length }} Records</span>
                  </div>
                </v-card-title>
                <v-divider class="my-0"></v-divider>
                <div class="table-wrapper">
                  <v-data-table class="professional-table striped-table" :search="search" :loading="TableLoadingFlag"
                    :item-key="tableOptions1.ItemKey" :headers="tableColumnsManual" :items="tableDataManual"
                    :items-per-page="tableOptions1.ItemsPerPage" :footer-props="tableOptions1.FooterProps">
                    <template v-slot:item.ActiveStatusTxt="{ item }">
                      <div class="d-flex align-center gap-2">
                        <v-chip :color="getActiveStatusColor(item.ActiveStatusTxt)" dark small outlined
                          class="status-chip">
                          <v-icon left x-small>mdi-check-circle</v-icon>
                          {{ item.ActiveStatusTxt }}
                        </v-chip>
                        <v-tooltip top v-if="item.Description">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="info" class="info-icon"
                              @click="showDescriptionPrompt(item.Description)" v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>View Description</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div class="table-actions-group">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon x-small color="info" @click="previewData(item)" v-bind="attrs" v-on="on"
                              class="action-icon-btn">
                              <v-icon small>mdi-file-search</v-icon>
                            </v-btn>
                          </template>
                          <span>Preview Details</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon x-small color="warning" @click="scoreData(item)" v-bind="attrs" v-on="on"
                              class="action-icon-btn">
                              <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit & Score</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <br />
        <br />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closePrompt"> Cancel </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import companyConfig from "@/company_config.json";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import LomPresidentAssign from "@/view/pages/erp/lom-president/LomPresidentAssign.vue";
import EventsPreview from "@/view/pages/erp/events/EventsPreview.vue";
import EventsScorePreview from "@/view/pages/erp/events-score/EventsScorePreview.vue";
import VotingCount from "@/view/pages/erp/lom/lom-information/VotingCount.vue";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {
    LomPresidentAssign,
    EventsPreview,
    EventsScorePreview,
    VotingCount,
  },
  props: {
    recordData: {
      required: true,
    },
    pageTitle: {
      type: String,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      SpeedDialFlag: false,
      TableLoadingFlag: false,
      DeleteLoadingFlag: false,
      UpdateEfficiencyScoreLoadingFlag: false,

      ExcelDownloadFlag: false,
      ExcelLoadingFlag: false,
      ExcelFileFlag: false,

      rows: [],

      Modules: {},

      tableData1: [],
      tableColumns1: [],
      tableOptions1: [],
      tableDataAutomatic: [],
      tableColumnsAutomatic: [],
      tableDataManual: [],
      tableColumnsManual: [],
      selected: [],
      search: "",
      CurrentYearId: 0,

      DownloadFlag: 0,
      ExcelFileName: "",
      excel_fields: {
        "Lom Id": "LomId",
        "Zone Id": "ZoneId",
        "Lom Name": "LomName",
        "President Name": "LomPresidentFullName",
        "LOM NAME": "LomName",
        "Mobile No": "LomPresidentMobileNo",
        "Email Id": "LomPresidentEmailid",
      },

      recordToEdit: "",
      record: {},
      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,
      scoreRecordPrompt: false,
      descriptionPrompt: false,
      editPageDescription: "Assign LOM President for JCI India",

      selectedData: {},
      selectedDescription: "",

      errorDialogPrompt: false,
      errorDialogTitle: "",
      errorDialogContent: "",

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      zone: {},
      lom: {},

      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCode: "",
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      MonthCodeRules: [],
      MonthCode: "",
      MonthCodeOptions: [],
      MonthCodeOptionsLoading: false,

      AreaCodeRules: [(v) => !!v || "Area is required"],
      AreaCode: "",
      AreaCodeOptions: [],
      AreaCodeOptionsLoading: false,

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      RegionCodeRules: [],
      RegionCode: "",
      RegionCodeOptions: [],
      RegionCodeOptionsLoading: false,

      LomCodeRules: [],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      EventTypeRules: [],
      EventType: "",
      EventTypeOptions: [
        { value: "", text: "--All--" },
        { value: 1, text: "National Events" },
        { value: 2, text: "Zone Events" },
        { value: 3, text: "LOM Events" },
      ],
      EventTypeOptionsLoading: false,

      FromDate: "",
      FromDateRules: [(v) => !!v || "From date is required"],
      DateModal1: false,

      ToDate: "",
      ToDateRules: [(v) => !!v || "To date is required"],
      DateModal2: false,

      EfficiencyIdRules: [],
      EfficiencyId: "",
      EfficiencyIdOptions: [],
      EfficiencyIdOptionsLoading: false,
    };
  },
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.LoadingFlag = false;
      this.ZoneCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      console.log("watch ZoneCode");
      this.LomCode = "";
      this.getLomCodeOptions();
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LoadingFlag = false;
      this.LomCodeOptionsLoading = false;
    },
    EfficiencyIdOptions: function () {
      console.log("watch EfficiencyIdOptions");
      this.LoadingFlag = false;
      this.EfficiencyIdOptionsLoading = false;
    },
  },
  methods: {
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt");
    },
    addRecord() {
      console.log("addRecord called");
      var url = "/lom/create";
      var params = {};
      this.pageRedirect(params, url);
    },
    editData(tr) {
      console.log("editData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        var url = "/events/edit";
        var id = tr.JciEventId;
        console.log("id=" + id);
        var params = {
          id: id,
        };
        this.pageRedirect(params, url);
      } else {
        var message = "Kindly select one event to edit";
        this.toast("error", message);
      }
    },
    resetForm() {
      this.$refs.form2.reset();
      this.tableData1 = [];
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      this.searchForm();
    },
    hideEditRecordPrompt() {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
      this.searchForm();
    },
    editAlert(tr) {
      console.log("editAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        var LomId = tr.LomId;
        console.log("LomId=" + LomId);
        this.record = tr;
        this.recordToEdit = LomId;
        this.editPageDescription =
          "Assign 2021 LOM President for " + tr.LomName;
        this.editRecordPrompt = true;
      } else {
        var message = "Kindly select one record to modifiy";
        this.toast("error", message);
      }
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },
    previewData(tr) {
      console.log("previewData called");
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.previewRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    hideScoreRecordPrompt() {
      console.log("hideScoreRecordPrompt called");
      this.scoreRecordPrompt = false;
      this.searchForm();
    },
    showDescriptionPrompt(description) {
      console.log("showDescriptionPrompt called");
      this.selectedDescription = description;
      this.descriptionPrompt = true;
    },
    hideDescriptionPrompt() {
      console.log("hideDescriptionPrompt called");
      this.descriptionPrompt = false;
      this.selectedDescription = "";
    },
    showErrorDialogPrompt(title, content) {
      console.log("showErrorDialogPrompt called");
      this.errorDialogTitle = title;
      this.errorDialogContent = content;
      this.errorDialogPrompt = true;
    },
    hideErrorDialogPrompt() {
      console.log("hideErrorDialogPrompt called");
      this.errorDialogPrompt = false;
      this.errorDialogTitle = "";
      this.errorDialogContent = "";
    },
    scoreData(tr) {
      console.log("scoreData called");
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.scoreRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      // this.JciYearCodeOptionsLoading = true;
      this.searchForm();
      // this.getEfficiencyIdOptions();
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var yearCode = this.JciYearCode;
      var areaCode = this.AreaCode;
      console.log("yearCode=" + yearCode + ", areaCode=" + areaCode);
      if (yearCode != "") {
        this.LoadingFlag = true;
        this.ZoneCodeOptionsLoading = true;
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: yearCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var YearCode = this.JciYearCode;
      var ZoneCode = this.ZoneCode;
      var RegionCode = this.RegionCode;
      console.log(
        "YearCode=" +
        YearCode +
        ", ZoneCode=" +
        ZoneCode +
        ", RegionCode=" +
        RegionCode
      );
      if (YearCode != "" && ZoneCode != "") {
        this.LoadingFlag = true;
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 3,
          YearCode: YearCode,
          ZoneCode: ZoneCode,
          AllOption: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (ZoneCode == "") {
          message += "Zone should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getEfficiencyIdOptions() {
      console.log("getEfficiencyIdOptions called");
      var yearCode = this.JciYearCode;
      console.log("yearCode=" + yearCode);
      if (yearCode != "") {
        this.LoadingFlag = true;
        this.EfficiencyIdOptionsLoading = true;
        var selectbox1_source = "EfficiencyId";
        var selectbox1_destination = "EfficiencyIdOptions";
        var selectbox1_url = "api/year-wise-efficiency/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          Year: yearCode,
          AllOption: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    searchForm() {
      console.log("searchForm is called");

      var message = "";

      // var validate1 = this.$refs.form2.validate();
      var validate1 = true;
      console.log("validate1=" + validate1);

      var JciYearCode = this.JciYearCode;
      console.log({ JciYearCode });

      var LomCode = this.LomCode;
      console.log({ LomCode });

      if (validate1 && JciYearCode != "" && LomCode != "") {
        this.LoadingFlag = true;
        this.tableData1 = [];
        this.TotalPoints = 0;
        this.CompulsaryPoints = 0;
        this.BonusPoints = 0;
        this.OptionalPoints = 0;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/year-wise-efficiency/lom-status";
        var upload = {
          UserInterface: 1,
          Year: JciYearCode,
          Lom: LomCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = {};
        var table = {};
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            console.log({ records });

            if (flag == 1) {
              var options = records.TableOptions;
              console.log({ options });

              thisIns.tableColumns1 = records.TableHeader;
              thisIns.tableOptions1 = options;
              thisIns.tableData1 = records.TableData;
              thisIns.tableColumnsAutomatic =
                records.TableHeaderAutomatic || records.TableHeader;
              thisIns.tableDataAutomatic = records.TableDataAutomatic || [];
              thisIns.tableColumnsManual =
                records.TableHeaderManual || records.TableHeader;
              thisIns.tableDataManual = records.TableDataManual || [];
              thisIns.toast("success", output);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (JciYearCode == "") {
          message += "Year should not be empty. ";
        }
        if (LomCode == "") {
          message += "LOM should not be empty. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    generateReportExcel() {
      console.log("generateReportExcel is called");

      // var validate1 = this.$refs.form2.validate();
      var FromDate = "2021-08-04";
      var ToDate = "2021-08-05";
      var validate1 = true;
      console.log(
        "validate1=" +
        validate1 +
        ", FromDate=" +
        FromDate +
        ", ToDate=" +
        ToDate
      );

      if (validate1) {
        this.ExcelFileName = "";
        this.ExcelLoadingFlag = true;
        this.ExcelFileFlag = false;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url =
          server_url + "api/reports/directory-information/generate-excel";
        var upload = {
          UserInterface: 1,
          YearCode: this.JciYearCode,
          ZoneCode: this.ZoneCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()

            thisIns.ExcelLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.ExcelFileName = records.ExcelFileName;
              thisIns.ExcelDownloadFlag = records.ExcelDownloadFlag;
              thisIns.ExcelFileFlag = true;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.ExcelLoadingFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.toast("error", message);
      }
    },
    deleteConfirmAlert(tr) {
      console.log("deleteConfirmAlert called");
      var message = "";
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        var htmlTxt = "";
        htmlTxt += "<br/> Event Type <b> " + tr.OrganizationTypeName + "</b>";
        htmlTxt += "<br/> Portfolio <b> " + tr.PortfolioShortCode + "</b>";
        htmlTxt += "<br/> Event name <b> " + tr.JciEventName + "</b>";
        htmlTxt += "<br/> 100% efficiency <b> " + tr.SubCriteriaTxt + "</b>";
        htmlTxt +=
          "<br/> Points <b> " +
          tr.PointsTypeName +
          " - " +
          tr.YearwiseEfficiencyPoints +
          " pts </b>";

        Swal.fire({
          title: "Do you want to continue?",
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Delete`,
          confirmButtonColor: "#d33",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.deleteData(tr.JciEventId);
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        if (n1 == 0) {
          message += "Kindly select one record to delete. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    deleteData(EventId) {
      console.log("deleteData is called");

      console.log("EventId=" + EventId);

      if (EventId > 0) {
        this.DeleteLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-event-score/destroy";
        var upload = {
          UserInterface: 1,
          EventId: EventId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = {};
        var table = {};
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.DeleteLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            table = response.data.TableContent;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.searchForm();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "Event Id should not be empty. ";
        this.sweetAlert("error", message, false);
      }
    },
    addScore(item) {
      console.log("addScore called");
      var tr = item;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        Swal.fire({
          title: "Confirm Update?",
          text: "Update efficiency score for: " + tr.FieldName,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, Update",
          confirmButtonColor: "#3085d6",
          cancelButtonText: "Cancel",
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateEfficiencyScore(tr);
          }
        });
      } else {
        var message = "Kindly select one record to score";
        this.toast("error", message);
      }
    },
    updateEfficiencyScore(item) {
      console.log("updateEfficiencyScore called");

      this.UpdateEfficiencyScoreLoadingFlag = true;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/jci-events/update-efficiency-score";

      var Upload = {
        FieldName: item.FieldName,
      };

      console.log("Upload=" + JSON.stringify(Upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: Upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.UpdateEfficiencyScoreLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          records = response.data.records;
          console.log("output=" + output + ", flag=" + flag);

          if (flag) {
            thisIns.sweetAlert("success", output);
            thisIns.searchForm();
          } else {
            thisIns.showErrorDialogPrompt("Efficiency Score Update", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.UpdateEfficiencyScoreLoadingFlag = false;

          thisIns.showErrorDialogPrompt(
            "Error",
            "Failed to update efficiency score"
          );
        });
    },
  },
  beforeMount() {
    var CurrentJciYearId = this.$session.get("CurrentJciYearId");
    // CurrentJciYearId = 11;
    CurrentJciYearId =
      CurrentJciYearId == (null || undefined) ? "" : CurrentJciYearId;
    console.log({ CurrentJciYearId });
    this.JciYearCode = CurrentJciYearId;

    console.log(this.$route.query.id);
    this.LomCode = this.recordData.LomId;

    console.log("LomCode=" + this.LomCode);

    this.refreshPageData();
  },
};
</script>
<style lang="scss">
// Color Palette (JCI Approved Colors)
$navy: #3a67b1;
$aqua: #0097d7;
$gold: #edbe38;
$seaform: #56bda3;
$text-90-black: #414042;
$text-off-black: #0a0f29;
$text-white: #ffffff;

$primary-color: $navy;
$secondary-color: $aqua;
$success-color: $seaform;
$warning-color: $gold;
$danger-color: #e74c3c;
$info-color: $aqua;
$light-bg: #f8fafc;
$bg-light: #f1f5f9;
$text-primary: $text-off-black;
$text-secondary: $text-90-black;
$border-color: #e2e8f0;
$gradient-main: linear-gradient(135deg, $navy 0%, $aqua 100%);

// Animations
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-12px);
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

#lo-efficiency-status-popup {
  background: transparent;
  min-height: auto;
  padding: 0;
  position: relative;

  .title-icon-wrapper {
    background: rgba(255, 255, 255, 0.2);
    padding: 16px;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(12px);
    border: 2px solid rgba(255, 255, 255, 0.3);
    transition: all 0.4s ease;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: scale(1.08) rotate(-5deg);
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
    }
  }

  .title-content {
    animation: slideInLeft 0.8s ease-out 0.1s backwards;
  }

  .page-main-title {
    font-size: 42px;
    font-weight: 900;
    color: white;
    margin: 0;
    letter-spacing: 1.2px;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
    line-height: 1.1;
  }

  .page-subtitle {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.95);
    margin: 8px 0 0 0;
    opacity: 0.95;
    letter-spacing: 0.3px;
    font-weight: 500;
  }

  .loader1 {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: not-allowed;
    scale: 0.7;
  }

  .action-buttons-group {
    display: flex;
    gap: 12px;
    animation: slideInRight 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);

    .modern-action-btn {
      background: rgba(255, 255, 255, 0.18) !important;
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
      border: 2px solid rgba(255, 255, 255, 0.35) !important;
      color: white !important;
      transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg,
            transparent,
            rgba(255, 255, 255, 0.4),
            transparent);
        transition: left 0.6s;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.28) !important;
        border-color: rgba(255, 255, 255, 0.5) !important;
        transform: translateY(-4px) scale(1.1);
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3) !important;

        &::before {
          left: 100%;
        }
      }

      &:active {
        transform: translateY(-2px) scale(1.05);
      }
    }
  }

  @keyframes fadeInScale {
    from {
      opacity: 0;
      transform: scale(0.95);
    }

    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes slideInRight {
    from {
      opacity: 0;
      transform: translateX(30px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  // ============================================
  // HEADER CARD
  // ============================================
  .header-card {
    background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
    border-radius: 20px 20px 0 0;
    border: none;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.5),
      0 0 30px rgba(0, 151, 215, 0.3);

    &::before {
      content: "";
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle,
          rgba(255, 255, 255, 0.1) 0%,
          transparent 70%);
      animation: float 8s ease-in-out infinite;
    }
  }

  .header-gradient {
    position: relative;
    z-index: 1;
  }

  .header-container {
    padding: 24px 32px !important;
  }

  .header-icon-box {
    background: rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(15px);
    border-radius: 14px;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid rgba(255, 255, 255, 0.3);
    flex-shrink: 0;
    animation: float 4s ease-in-out infinite;

    .icon-white {
      color: $text-white !important;
    }
  }

  .header-title-bar {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .header-title {
    font-size: 28px;
    font-weight: 800;
    color: $text-white;
    margin: 0;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
  }

  .header-subtitle {
    font-size: 14px;
    opacity: 0.95;
    color: $text-white;
    font-weight: 500;
    margin: 0;
  }

  .gap-3 {
    gap: 1rem !important;
  }

  .header-action-btn {
    background: rgba(255, 255, 255, 0.2) !important;
    border: 1px solid rgba(255, 255, 255, 0.3);
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.3) !important;
      transform: rotate(90deg);
    }
  }

  .sticky-header {
    position: sticky;
    top: 0;
    z-index: 100;
  }

  .status-cards-row {
    margin-left: -12px;
    margin-right: -12px;
  }

  .content-card {
    background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%) !important;
    border: none !important;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
    border-radius: 0 0 20px 20px !important;
  }

  .transparent-card {
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
  }

  // ============================================
  // STATUS CARDS
  // ============================================
  .status-card {
    border-radius: 18px !important;
    border: none !important;
    transition: all 0.45s cubic-bezier(0.4, 0, 0.2, 1);
    animation: fadeInScale 0.7s ease-out;
    position: relative;
    overflow: hidden;
    padding: 24px !important;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg,
          rgba(255, 255, 255, 0.12) 0%,
          transparent 100%);
      pointer-events: none;
      z-index: 1;
    }

    &:hover {
      transform: translateY(-10px) scale(1.01);
      box-shadow: 0 28px 80px rgba(58, 103, 177, 0.35);
    }

    &--success {
      background: linear-gradient(135deg,
          $seaform 0%,
          darken($seaform, 10%) 100%) !important;
      border: none !important;
      box-shadow: 0 12px 40px rgba($seaform, 0.3) !important;
      color: $text-white !important;

      .status-card-title,
      .status-value,
      .v-icon {
        color: $text-white !important;
        border-color: rgba(255, 255, 255, 0.2) !important;
      }

      .status-badge {
        background: rgba(255, 255, 255, 0.2) !important;
        color: white !important;
        border: 1px solid rgba(255, 255, 255, 0.4) !important;
      }
    }

    &--pending {
      background: linear-gradient(135deg,
          lighten($seaform, 15%) 0%,
          $seaform 100%) !important;
      border: none !important;
      box-shadow: 0 12px 40px rgba($seaform, 0.25) !important;
      color: $text-off-black !important;

      .status-card-title,
      .status-value,
      .v-icon {
        color: $text-off-black !important;
        border-color: rgba(0, 0, 0, 0.1) !important;
      }

      .status-badge {
        background: rgba(255, 255, 255, 0.5) !important;
        color: darken($gold, 30%) !important;
        border: 1px solid rgba(255, 255, 255, 0.6) !important;
      }
    }

    &--info {
      background: linear-gradient(135deg,
          $navy 0%,
          lighten($navy, 10%) 100%) !important;
      border: none !important;
      box-shadow: 0 12px 40px rgba($navy, 0.3) !important;
      color: $text-white !important;

      .status-card-title,
      .status-value,
      .v-icon {
        color: $text-white !important;
        border-color: rgba(255, 255, 255, 0.2) !important;
      }

      .points-breakdown {
        background: rgba(255, 255, 255, 0.1) !important;
        border: 1px solid rgba(255, 255, 255, 0.2) !important;

        .point-item {
          border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
          color: rgba(255, 255, 255, 0.9) !important;

          &:last-child {
            border-bottom: none !important;
          }

          .point-label {
            color: rgba(255, 255, 255, 0.8) !important;
          }

          .point-value {
            color: $text-white !important;
          }
        }
      }
    }

    .status-card-title {
      font-size: 16px;
      font-weight: 700;
      color: inherit;
      text-transform: uppercase;
      letter-spacing: 0.8px;
      padding: 0 0 16px 0;
      border-bottom: 2px solid rgba(0, 0, 0, 0.08);
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 16px;
      position: relative;
      z-index: 2;
    }

    .status-card-content {
      padding: 0;
      text-align: center;
      position: relative;
      z-index: 2;
    }

    .status-value {
      font-size: 40px;
      font-weight: 900;
      color: inherit;
      margin-bottom: 16px;
      letter-spacing: 1.2px;
      line-height: 1.1;
    }

    .status-badge {
      display: inline-block;
      padding: 10px 20px;
      border-radius: 24px;
      font-weight: 700;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      transition: all 0.3s ease;
      backdrop-filter: blur(10px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

      &.badge-success {
        background: linear-gradient(135deg, #dcfce7 0%, #a7f3d0 100%);
        color: #047857;
        border: 2px solid #10b981;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(16, 185, 129, 0.3);
        }
      }

      &.badge-pending {
        background: linear-gradient(135deg, #fef3c7 0%, #fcd34d 100%);
        color: #92400e;
        border: 2px solid #f59e0b;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(245, 158, 11, 0.3);
        }
      }
    }

    .points-breakdown {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 20px;
      text-align: left;
      background: linear-gradient(135deg,
          rgba(0, 0, 0, 0.03) 0%,
          rgba(0, 0, 0, 0.01) 100%);
      padding: 16px;
      border-radius: 12px;
      border: 1px solid rgba(58, 103, 177, 0.1);
      backdrop-filter: blur(8px);
    }

    .point-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;
      font-weight: 500;
      border-bottom: 1px solid rgba(58, 103, 177, 0.05);
      transition: all 0.2s ease;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background: rgba(58, 103, 177, 0.03);
        padding: 8px 4px;
      }

      .point-label {
        color: $text-secondary;
        font-size: 13px;
        font-weight: 600;
      }

      .point-value {
        color: $primary-color;
        font-weight: 700;
        font-size: 16px;
        font-family: "Courier New", monospace;
      }
    }
  }

  .points-value {
    color: #2563eb;
    font-family: "Courier New", monospace;
  }

  // ============================================
  // EMPTY STATE
  // ============================================
  .empty-state {
    text-align: center;
    padding: 80px 32px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 18px;
    border: 2px dashed rgba(58, 103, 177, 0.2);
    animation: fadeInScale 0.7s ease-out;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle,
          rgba(58, 103, 177, 0.05) 0%,
          transparent 70%);
      z-index: 0;
    }

    h3 {
      font-size: 26px;
      font-weight: 700;
      color: $text-primary;
      margin: 0;
      position: relative;
      z-index: 1;
    }

    p {
      color: $text-secondary;
      margin: 12px 0 0 0;
      font-size: 15px;
      line-height: 1.6;
      position: relative;
      z-index: 1;
    }
  }

  // ============================================
  // TABLE STYLING - MODERN & PROFESSIONAL
  // ============================================
  .table-wrapper {
    overflow-x: auto;
    border-radius: 18px;
    background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
    padding: 0;
    border: 2px solid rgba(58, 103, 177, 0.12);
    animation: fadeInScale 0.8s ease-out;
    position: relative;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 16px 48px rgba(58, 103, 177, 0.25),
      0 0 40px rgba(0, 151, 215, 0.15), inset 0 1px 1px rgba(255, 255, 255, 0.5);

    &:hover {
      box-shadow: 0 20px 64px rgba(58, 103, 177, 0.35),
        0 0 48px rgba(0, 151, 215, 0.2),
        inset 0 1px 1px rgba(255, 255, 255, 0.6);
    }

    .professional-table {
      width: 100%;

      &.striped-table tbody tr:nth-child(even) {
        background: linear-gradient(90deg,
            rgba(58, 103, 177, 0.03) 0%,
            transparent 100%);
      }

      thead tr {
        background: linear-gradient(90deg,
            rgba(58, 103, 177, 0.12) 0%,
            rgba(0, 151, 215, 0.08) 100%);
        border-bottom: 2px solid rgba(58, 103, 177, 0.25);
        position: sticky;
        top: 0;
        z-index: 10;

        th {
          font-weight: 700;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.8px;
          color: $navy;
          background: transparent !important;
          padding: 16px 12px !important;
          white-space: nowrap;
          transition: all 0.2s ease;

          &:hover {
            color: $aqua;
          }
        }
      }

      tbody tr {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border-bottom: 1px solid rgba(58, 103, 177, 0.08);
        background: linear-gradient(90deg, #ffffff 0%, #fafbff 100%);

        &:hover {
          background: linear-gradient(90deg,
              rgba(58, 103, 177, 0.08) 0%,
              rgba(0, 151, 215, 0.04) 100%);
          box-shadow: inset 0 0 12px rgba(58, 103, 177, 0.12),
            0 4px 8px rgba(58, 103, 177, 0.08);
          transform: scale(1.01);
        }

        &:last-child {
          border-bottom: none;
        }

        td {
          padding: 14px 12px !important;
          font-size: 14px;
        }
      }
    }
  }

  .data-table-card {
    border-radius: 18px !important;
    border: 2px solid rgba(58, 103, 177, 0.15) !important;
    box-shadow: 0 16px 56px rgba(58, 103, 177, 0.2),
      0 0 36px rgba(0, 151, 215, 0.12), inset 0 1px 1px rgba(255, 255, 255, 0.6) !important;
    transition: all 0.45s cubic-bezier(0.4, 0, 0.2, 1);
    animation: fadeInScale 0.75s ease-out;
    background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%) !important;
    position: relative;
    overflow: visible;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(circle at 0% 0%,
          rgba(58, 103, 177, 0.06) 0%,
          transparent 50%),
        radial-gradient(circle at 100% 100%,
          rgba(0, 151, 215, 0.06) 0%,
          transparent 50%);
      pointer-events: none;
      z-index: 1;
      border-radius: 18px;
    }

    &:hover {
      box-shadow: 0 20px 72px rgba(58, 103, 177, 0.3),
        0 0 48px rgba(0, 151, 215, 0.18),
        inset 0 1px 1px rgba(255, 255, 255, 0.7) !important;
      transform: translateY(-6px);
    }

    &.automatic-card {
      .table-card-title.automatic-title {
        background: linear-gradient(90deg,
            rgba(16, 185, 129, 0.08) 0%,
            rgba(16, 185, 129, 0.04) 100%);
        border-bottom: 2px solid rgba(16, 185, 129, 0.15) !important;
      }
    }

    .table-card-title {
      font-size: 17px;
      font-weight: 700;
      color: $text-primary;
      text-transform: uppercase;
      letter-spacing: 0.8px;
      padding: 20px 24px;
      display: flex;
      align-items: center;
      gap: 12px;
      background: linear-gradient(90deg,
          rgba(58, 103, 177, 0.08) 0%,
          rgba(0, 151, 215, 0.05) 100%);
      border-bottom: 2px solid rgba(58, 103, 177, 0.1);
      position: relative;
      z-index: 2;

      .title-with-icon {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;

        .v-icon {
          transition: transform 0.3s ease;
        }

        &:hover .v-icon {
          transform: rotate(15deg) scale(1.1);
        }
      }

      .records-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: linear-gradient(135deg,
            $primary-color 0%,
            $secondary-color 100%);
        color: $text-white;
        padding: 8px 16px;
        border-radius: 24px;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        box-shadow: 0 4px 12px rgba(58, 103, 177, 0.3);
        transition: all 0.3s ease;

        &:hover {
          transform: scale(1.05);
          box-shadow: 0 6px 16px rgba(58, 103, 177, 0.4);
        }

        .v-icon {
          font-size: 12px;
        }
      }
    }
  }

  .table-record-count {
    display: inline-block;
    background: linear-gradient(135deg,
        $primary-color 0%,
        $secondary-color 100%);
    color: $text-white;
    padding: 6px 14px;
    border-radius: 24px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 12px rgba(58, 103, 177, 0.3);
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 6px 16px rgba(58, 103, 177, 0.4);
    }
  }

  .table-actions-group {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;

    .action-icon-btn {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      width: 36px !important;
      height: 36px !important;

      &:hover {
        transform: scale(1.3);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
      }

      &:active {
        transform: scale(1.15);
      }
    }
  }

  .status-chip {
    transition: all 0.3s ease;
    backdrop-filter: blur(8px);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    }

    .v-icon {
      margin-right: 4px;
    }
  }

  .info-icon {
    cursor: pointer;
    transition: all 0.3s ease;
    opacity: 0.7;

    &:hover {
      opacity: 1;
      transform: scale(1.3);
      filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15));
    }
  }

  .coming-soon-btn {
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    }
  }

  // ============================================
  // SEARCH FIELD - MODERN DESIGN
  // ============================================
  .search-section {
    position: relative;
    animation: slideInUp 0.6s ease-out;
    display: flex;
    align-items: center;
    gap: 12px;

    .search-icon {
      position: absolute;
      left: 16px;
      opacity: 0.7;
      pointer-events: none;
      z-index: 2;
      transition: all 0.3s ease;
    }

    .search-field {
      padding-left: 44px !important;
      width: 100%;

      &::v-deep {
        .v-input__prepend-outer {
          margin-right: 0;
        }

        .v-input__control .v-input__slot {
          background: linear-gradient(135deg,
              rgba(255, 255, 255, 0.9) 0%,
              rgba(255, 255, 255, 0.7) 100%) !important;
          border-radius: 14px !important;
          padding: 12px 16px 12px 44px !important;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(58, 103, 177, 0.1);
          position: relative;
          z-index: 1;

          &::before {
            border-bottom-color: rgba(58, 103, 177, 0.15) !important;
          }

          &:hover::before {
            border-bottom-color: $aqua !important;
          }
        }

        .v-input__control.focused .v-input__slot {
          background: linear-gradient(135deg,
              #ffffff 0%,
              rgba(255, 255, 255, 0.95) 100%) !important;
          box-shadow: 0 8px 24px rgba(58, 103, 177, 0.2);
          padding-left: 44px !important;

          &::before {
            border-bottom-color: $navy !important;
          }
        }

        .v-input__append-inner {
          margin-top: 0;
          opacity: 0.7;

          &:hover {
            opacity: 1;
          }
        }
      }
    }
  }

  .search-field {
    animation: slideInUp 0.6s ease-out;
  }

  // ============================================
  // DOWNLOAD BUTTON - PREMIUM STYLE
  // ============================================
  .download-btn {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    border-radius: 14px;
    padding: 14px 32px !important;
    font-size: 13px;
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
    box-shadow: 0 8px 24px rgba(16, 185, 129, 0.3);
    display: inline-flex;
    align-items: center;
    gap: 8px;

    &.premium-btn {
      box-shadow: 0 12px 40px rgba(16, 185, 129, 0.4);
      border: 2px solid rgba(255, 255, 255, 0.2);
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg,
          transparent,
          rgba(255, 255, 255, 0.3),
          transparent);
      transition: left 0.6s;
      z-index: 1;
    }

    .btn-text {
      position: relative;
      z-index: 2;
    }

    .v-icon {
      position: relative;
      z-index: 2;
      transition: all 0.3s ease;
    }

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 16px 48px rgba(16, 185, 129, 0.5);

      &::before {
        left: 100%;
      }

      .v-icon:first-child {
        transform: translateY(-2px);
      }

      .v-icon:last-child {
        transform: translateX(3px);
      }
    }

    &:active {
      transform: translateY(-1px);
    }
  }

  // ============================================
  // DESCRIPTION DIALOG
  // ============================================

  // ============================================
  // PAGE CONTENT & FOOTER
  // ============================================
  .page-content {
    padding: 32px !important;
    position: relative;
    z-index: 2;
  }

  .page-footer {
    height: 24px;
  }

  // ============================================
  // RESPONSIVE DESIGN
  // ============================================
  @media (max-width: 1200px) {
    padding: 24px 12px;

    .header-section {
      margin-left: -12px;
      margin-right: -12px;
    }

    .page-main-title {
      font-size: 36px;
    }

    .page-subtitle {
      font-size: 14px;
    }

    .title-container {
      gap: 16px;
    }

    .title-icon-wrapper {
      min-width: 56px;
      padding: 12px;
    }

    .data-table-card {
      margin-bottom: 20px;

      .table-card-title {
        font-size: 15px;
        padding: 16px 20px;
      }
    }
  }

  @media (max-width: 960px) {
    padding: 20px 10px;

    .header-gradient {
      padding: 24px;
    }

    .header-top {
      flex-direction: column;
      gap: 16px;
    }

    .title-container {
      width: 100%;
      min-width: auto;
    }

    .action-buttons-group {
      width: 100%;
      justify-content: flex-start;
    }

    .page-main-title {
      font-size: 32px;
    }

    .page-subtitle {
      font-size: 13px;
    }

    .search-section {
      gap: 8px;
    }

    .data-table-card {
      .table-card-title {
        font-size: 14px;
        padding: 14px 16px;
        flex-wrap: wrap;

        .title-with-icon {
          width: 100%;
          margin-bottom: 8px;
        }

        .records-badge {
          width: 100%;
          justify-content: center;
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 16px 8px;

    .header-gradient {
      padding: 20px;
      border-radius: 0 0 20px 20px;
    }

    .header-section {
      margin-left: -8px;
      margin-right: -8px;
      margin-bottom: 20px;
    }

    .title-icon-wrapper {
      min-width: 50px;
      padding: 10px;
    }

    .page-main-title {
      font-size: 28px;
      letter-spacing: 0.8px;
    }

    .page-subtitle {
      font-size: 12px;
    }

    .modern-action-btn {
      width: 38px !important;
      height: 38px !important;
      padding: 6px !important;

      .v-icon {
        font-size: 18px !important;
      }
    }

    .status-card {
      padding: 16px !important;
      margin-bottom: 12px;

      .status-card-title {
        font-size: 13px;
        padding: 0 0 10px 0;
      }

      .status-value {
        font-size: 32px;
        margin-bottom: 12px;
      }

      .status-badge {
        padding: 8px 14px;
        font-size: 10px;
      }

      .points-breakdown {
        padding: 10px;
        gap: 4px;
        margin-top: 10px;
      }

      .point-item {
        font-size: 11px;
        padding: 3px 0;
      }
    }

    .search-section {
      .search-icon {
        left: 12px;
      }

      .search-field {
        &::v-deep .v-input__control .v-input__slot {
          padding: 10px 12px 10px 38px !important;
        }
      }
    }

    .data-table-card {
      margin-bottom: 12px;

      .table-card-title {
        font-size: 12px;
        padding: 12px;
        flex-direction: column;

        .title-with-icon {
          width: 100%;
          margin-bottom: 8px;
        }

        .records-badge {
          width: 100%;
          justify-content: center;
          padding: 6px 12px;
          font-size: 10px;
        }
      }

      &::v-deep .professional-table {
        font-size: 11px;

        thead th {
          font-size: 10px;
          padding: 10px 6px !important;
          letter-spacing: 0.3px;
        }

        tbody td {
          padding: 8px 6px !important;
        }
      }
    }

    .table-wrapper {
      border-radius: 12px;
    }

    .table-actions-group {
      gap: 6px;

      .action-icon-btn {
        width: 32px !important;
        height: 32px !important;
      }
    }

    .empty-state {
      padding: 50px 20px;

      h3 {
        font-size: 20px;
      }

      p {
        font-size: 13px;
      }
    }

    .download-btn {
      width: 100%;
      padding: 12px 16px !important;
      font-size: 12px;
      gap: 6px;

      .v-icon {
        font-size: 16px !important;
      }
    }

    .status-chip {
      font-size: 11px;
      padding: 4px 8px;

      .v-icon {
        font-size: 12px !important;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 12px 6px;

    .header-gradient {
      padding: 16px;
    }

    .header-section {
      margin-bottom: 16px;
    }

    .title-container {
      gap: 12px;
    }

    .title-icon-wrapper {
      min-width: 46px;
      padding: 8px;
    }

    .page-main-title {
      font-size: 24px;
      letter-spacing: 0.6px;
    }

    .page-subtitle {
      font-size: 11px;
      margin-top: 4px;
    }

    .action-buttons-group {
      gap: 8px;
    }

    .modern-action-btn {
      width: 36px !important;
      height: 36px !important;

      .v-icon {
        font-size: 16px !important;
      }
    }

    .status-card {
      padding: 12px !important;
      border-radius: 10px !important;

      .status-card-title {
        font-size: 11px;
      }

      .status-value {
        font-size: 24px;
      }

      .status-badge {
        padding: 6px 12px;
        font-size: 9px;
      }

      .points-breakdown {
        padding: 8px;
        gap: 2px;
      }

      .point-item {
        font-size: 10px;
      }
    }

    .search-section {
      .search-icon {
        left: 10px;
        font-size: 18px !important;
      }

      .search-field {
        &::v-deep .v-input__control .v-input__slot {
          padding: 8px 10px 8px 36px !important;
          border-radius: 10px !important;
        }
      }
    }

    .data-table-card {
      .table-card-title {
        font-size: 11px;
        padding: 10px;

        .records-badge {
          font-size: 9px;
          padding: 4px 8px;
        }
      }

      &::v-deep .professional-table {
        font-size: 10px;

        thead th {
          font-size: 9px;
          padding: 8px 4px !important;
        }

        tbody td {
          padding: 6px 4px !important;
        }
      }
    }

    .table-wrapper {
      border-radius: 10px;
    }

    .table-actions-group {
      gap: 4px;

      .action-icon-btn {
        width: 30px !important;
        height: 30px !important;

        .v-icon {
          font-size: 14px !important;
        }
      }
    }

    .empty-state {
      padding: 40px 16px;

      h3 {
        font-size: 18px;
      }

      p {
        font-size: 12px;
      }
    }

    .download-btn {
      padding: 10px 12px !important;
      font-size: 11px;
      gap: 4px;
      flex-wrap: wrap;

      .v-icon {
        font-size: 14px !important;
      }
    }
  }

  @media (max-width: 480px) {
    padding: 8px 4px;

    .header-gradient {
      padding: 12px;
    }

    .title-container {
      gap: 8px;
    }

    .title-icon-wrapper {
      min-width: 42px;
      padding: 6px;
    }

    .page-main-title {
      font-size: 20px;
    }

    .page-subtitle {
      font-size: 10px;
    }

    .status-card {
      .status-value {
        font-size: 20px;
      }

      .status-card-title {
        font-size: 10px;
      }
    }

    .data-table-card {
      .table-card-title {
        font-size: 10px;
        padding: 8px;
      }

      &::v-deep .professional-table {
        font-size: 9px;
      }
    }

    .download-btn {
      padding: 8px 10px !important;
      font-size: 10px;
    }
  }
}

// Utility classes
.gap-4 {
  gap: 16px;
}

.d-flex {
  display: flex;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.align-center {
  align-items: center;
}

.overflow-hidden {
  overflow: hidden;
}
</style>

<style lang="scss">
// Global styles for dialogs that render outside the app root
$navy: #3a67b1;
$aqua: #0097d7;

// ============================================
// DESCRIPTION DIALOG
// ============================================
.description-dialog {
  border-radius: 20px !important;
  border: none !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  background: #ffffff !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .description-title {
    background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
    padding: 24px 24px 30px 24px !important;
    color: white !important;
    position: relative;
    align-items: flex-start;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 20px;
      background: #ffffff;
      border-radius: 20px 20px 0 0;
    }

    .description-icon-box {
      background: rgba(255, 255, 255, 0.2);
      width: 48px;
      height: 48px;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      backdrop-filter: blur(8px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.3);
    }

    .headline-text {
      font-size: 18px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      line-height: 1.2;
      color: white !important;
    }

    .subtitle-text {
      font-size: 13px;
      opacity: 0.9;
      font-weight: 400;
      margin-top: 2px;
      color: rgba(255, 255, 255, 0.9) !important;
    }

    .close-top-btn {
      background: rgba(255, 255, 255, 0.15);
      border-radius: 50%;
      width: 36px;
      height: 36px;
      margin-left: 8px;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: rotate(90deg);
      }

      .v-icon {
        color: white !important;
      }
    }
  }

  .description-body {
    padding: 10px 30px 30px 30px !important;
    min-height: 120px;

    .text-content {
      font-size: 16px;
      line-height: 1.7;
      color: #334155;
      font-weight: 500;
      white-space: pre-wrap;
    }

    .empty-state-small {
      text-align: center;
      padding: 30px 0;
      opacity: 0.6;

      p {
        margin-top: 10px;
        font-size: 14px;
      }
    }
  }

  .description-actions {
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;

    .close-action-btn {
      background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 1px;
      height: 48px;
      width: 20px;
      border-radius: 12px;
      font-size: 14px;
      box-shadow: 0 4px 6px rgba(58, 103, 177, 0.2);
      transition: all 0.3s ease;
      color: white !important;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 12px rgba(58, 103, 177, 0.3);
      }
    }
  }
}

.custom-loader {
  background-color: transparent !important;
}

.custom-loader .v-overlay__scrim {
  background-color: rgba(0, 0, 0, 0.75) !important;
  margin-top: 130px !important;
  height: 600px !important;
  width: 100% !important;
}

.loader-container {
  text-align: center;
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 28px;
  padding: 24px;
  backdrop-filter: blur(18px);
  max-width: 360px;
  margin: 0 auto;
}

/* From Uiverse.io by Ratinax - JCI Final Theme */
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: not-allowed;
  scale: 0.7;
}

.central {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 10em;
  height: 10em;
  border-radius: 50%;
  box-shadow: 0.5em 1em 1em #3A67B1,
    -0.5em 0.5em 1em #0097D7,
    0.5em -0.5em 1em #EDBE38,
    -0.5em -0.5em 1em #56BDA3;
}

.external-shadow {
  width: 10em;
  height: 10em;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  box-shadow: 0.5em 0.5em 3em #3A67B1,
    -0.5em 0.5em 3em #0097D7,
    0.5em -0.5em 3em #EDBE38,
    -0.5em -0.5em 3em #56BDA3;
  z-index: 999;
  animation: rotate 3s linear infinite;
  background-color: #0A0F29;
}

.intern {
  position: absolute;
  color: white;
  z-index: 9999;
  font-weight: 600;
  font-size: 1.2em;
}

.intern::before {
  content: "100%";
  animation: percent 2s ease-in-out infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes percent {
  0% {
    content: '0%';
  }

  25% {
    content: '25%';
  }

  33% {
    content: '33%';
  }

  42% {
    content: '42%';
  }

  51% {
    content: '51%';
  }

  67% {
    content: '67%';
  }

  74% {
    content: '74%';
  }

  75% {
    content: '75%';
  }

  86% {
    content: '86%';
  }

  95% {
    content: '95%';
  }

  98% {
    content: '98%';
  }

  99% {
    content: '99%';
  }
}

.loader-text {
  margin-top: 16px;
  font-size: 18px;
  font-weight: 600;
  color: white;
  letter-spacing: 1px;
}

.loader-dots::after {
  content: "...";
  animation: dotsLoading 1.4s steps(4, end) infinite;
}

@keyframes dotsLoading {

  0%,
  20% {
    content: ".";
  }

  40% {
    content: "..";
  }

  60%,
  100% {
    content: "...";
  }
}

// ============================================
// ERROR DESCRIPTION DIALOG
// ============================================
.error-description-dialog {
  border-radius: 12px !important;
  border: none !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
  background: #ffffff !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .error-description-header {
    background: linear-gradient(135deg, #3a67b1 0%, #0097d7 100%) !important;
    padding: 20px 24px !important;
    color: white !important;
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    border-bottom: 4px solid rgba(255, 255, 255, 0.2);

    .error-header-icon {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 40px;
      min-height: 40px;
      backdrop-filter: blur(10px);
    }

    .error-header-title {
      font-size: 16px;
      font-weight: 700;
      margin: 0;
      color: white;
      letter-spacing: 0.3px;
      flex: 1;
    }

    .error-header-close-btn {
      color: rgba(255, 255, 255, 0.8) !important;
      transition: all 0.3s ease;

      &:hover {
        color: white !important;
        background: rgba(255, 255, 255, 0.15) !important;
      }
    }
  }

  .error-description-content {
    padding: 0 !important;
    background: #fafbfc !important;
    flex: 1;
    max-height: 400px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;

    .error-content-header {
      padding: 16px 24px;
      border-bottom: 2px solid #e2e8f0;
      background: #f1f5f9;
      display: flex;
      align-items: center;
      gap: 10px;

      .error-section-title {
        font-size: 13px;
        font-weight: 700;
        margin: 0;
        color: #00000097;
        text-transform: uppercase;
        letter-spacing: 0.8px;
      }

      .v-icon {
        color: #0097d7 !important;
        flex-shrink: 0;
      }
    }

    .error-content-body {
      padding: 20px 24px;
      flex: 1;
      overflow-y: auto;
      border-left: 4px solid #3a67b1;
      background: #ffffff;

      .error-content-inner {
        font-size: 14px;
        line-height: 1.7;
        color: #414042;
        word-wrap: break-word;

        p {
          margin: 14px 0;
          padding: 0;
          position: relative;
          display: block;
          white-space: normal;

          &::before {
            content: "";
            position: absolute;
            left: -20px;
            top: 2px;
            width: 16px;
            height: 16px;
            background: linear-gradient(135deg, #3a67b1 0%, #0097d7 100%);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 11px;
            font-weight: bold;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'/%3E%3C/svg%3E");
            background-size: 11px 11px;
            background-repeat: no-repeat;
            background-position: center;
          }
        }

        a {
          color: #0097d7;
          text-decoration: none;
          font-weight: 600;
          transition: all 0.2s ease;

          &:hover {
            color: #3a67b1;
            text-decoration: underline;
          }
        }

        strong,
        b {
          font-weight: 700;
          color: #0097d7;
        }

        ul,
        ol {
          margin: 14px 0;
          padding-left: 20px;

          li {
            margin: 10px 0;
            position: relative;
            padding-left: 8px;
            line-height: 1.7;

            &::before {
              content: "•";
              position: absolute;
              left: -12px;
              color: #0097d7;
              font-weight: bold;
              font-size: 16px;
            }
          }
        }

        hr {
          border: none;
          border-top: 1px solid #e2e8f0;
          margin: 18px 0;
        }

        .info-box {
          background: linear-gradient(135deg,
              rgba(58, 103, 177, 0.08) 0%,
              rgba(0, 151, 215, 0.08) 100%);
          border-left: 4px solid #3a67b1;
          padding: 12px 16px;
          border-radius: 6px;
          margin: 12px 0;
        }
      }
    }
  }

  .error-description-footer {
    background: #f8fafc;
    padding: 16px 24px !important;
    border-top: 1px solid #e2e8f0;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    align-items: center;

    .error-action-btn-primary {
      background: linear-gradient(135deg, #3a67b1 0%, #0097d7 100%) !important;
      color: white !important;
      border: none !important;
      padding: 10px 28px !important;
      border-radius: 6px;
      font-weight: 600;
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(58, 103, 177, 0.25);
      min-width: 140px;

      &:hover {
        box-shadow: 0 6px 20px rgba(58, 103, 177, 0.35);
        transform: translateY(-2px);
      }

      &:active {
        transform: translateY(0px);
        box-shadow: 0 2px 8px rgba(58, 103, 177, 0.2);
      }
    }

    .error-action-btn-secondary {
      color: #414042 !important;
      padding: 10px 24px !important;
      border-radius: 6px;
      font-weight: 600;
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(58, 103, 177, 0.08) !important;
        color: #3a67b1 !important;
      }
    }
  }
}
</style>